var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNicheGrocery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Amazon-Web-Service-Marketplaces-Cart--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Amazon Web Service Marketplaces Cart Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.548 4.21c0.177 -0.566 0.675 -0.916 1.164 -0.916h1.16a1 1 0 1 0 0 -2h-1.16c-1.44 0 -2.676 0.997 -3.084 2.355a0.982 0.982 0 0 0 -0.01 0.034l-3.092 11.79c-0.007 0.03 -0.014 0.06 -0.019 0.09 -0.002 0.014 -0.02 0.07 -0.097 0.132a0.435 0.435 0 0 1 -0.27 0.095H4.705c-0.138 0 -0.322 -0.095 -0.392 -0.338l-2.224 -7.64a1 1 0 1 0 -1.92 0.56l2.221 7.63 0.001 0.002c0.318 1.109 1.293 1.786 2.314 1.786H15.14c1.098 0 2.121 -0.765 2.33 -1.847L20.548 4.21ZM6.273 19.189a2.336 2.336 0 1 0 0 4.672 2.336 2.336 0 0 0 0 -4.672Zm7.888 0a2.336 2.336 0 1 0 0 4.672 2.336 2.336 0 0 0 0 -4.672ZM7.127 9.045l-1.923 0.82v2.538l1.923 0.947 1.998 -0.953V9.871l-1.998 -0.826Zm3.498 0.82v2.538l1.923 0.947 1.998 -0.953V9.871l-1.998 -0.826 -1.923 0.82Zm1.168 -2.13V5.139l-1.923 -0.82 -1.998 0.826 0 2.586 1.998 0.826 1.923 -0.82Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNicheGrocery);
export default ForwardRef;